import { portalBase2v, publicBase2v } from '@App/dicts/pathes'

export class User {
    userInfo = portalBase2v('user/me')
    editUserInfo = portalBase2v('user/me')
    editUserSettings = portalBase2v('user/settings')
    userEnable2fa = publicBase2v('user/enable-2fa')
    userConfirmEnable2fa = publicBase2v('user/enable-2fa/confirm')
    attemptIdvSignedIn = (userExposedId: string) => portalBase2v(`user/${userExposedId}/idv/attempt`)
    createUserAndAttemptIdv = publicBase2v(`user`)
    activateUser = (activationCode: string) => publicBase2v(`user/activation-code/${activationCode}`)
    sendResetPasswordCode = portalBase2v('user/request-password-change')
    userPassChange = portalBase2v('user/change-password')
}
